import { Theme } from "@mui/material";

export const VariantStyles = (theme: Theme) => {
  return {
    default: {
      '& .MuiPaper-root': {
        padding: theme.space._500,
      }
    },
    noPadding: {
      '& .MuiPaper-root': {
        padding: 0,
      }
    },
    withShadow: {
      '& .MuiPaper-root': {
        padding: theme.space._500,
        boxShadow: `0 8px 20px rgba(0, 0, 0, .7)`
      },
    },
    withShadowWithoutPadding: {
      '& .MuiPaper-root': {
        padding: 0,
        boxShadow: `0 8px 20px rgba(0, 0, 0, .7)`
      },
    },
    fitContent: {
      '& .MuiPaper-root': {
        padding: theme.space._500,
        minWidth: "fit-content",
      }
    }
  };
};